var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSomethingWrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.6,163.49a7.15,7.15,0,0,1-2.37-.4L352,158.85a7.29,7.29,0,0,1-4.75-5.49l-2.45-12.73a7.26,7.26,0,0,1,2.38-6.86l9.79-8.48a7.3,7.3,0,0,1,7.14-1.38l12.24,4.25a7.27,7.27,0,0,1,4.76,5.49l2.44,12.72a7.31,7.31,0,0,1-2.37,6.87l-9.8,8.48A7.28,7.28,0,0,1,366.6,163.49ZM355,151.43l11.44,4,9.16-7.92-2.29-11.89-11.44-4-9.15,7.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.44,126.54a7.15,7.15,0,0,1-2.37-.4l-6.2-2.15a7.27,7.27,0,0,1-4.75-5.49l-1.24-6.44a7.28,7.28,0,0,1,2.37-6.86l5-4.3a7.27,7.27,0,0,1,7.13-1.37l6.19,2.15a7.27,7.27,0,0,1,4.76,5.49l1.24,6.44a7.26,7.26,0,0,1-2.38,6.86l-5,4.3A7.33,7.33,0,0,1,509.44,126.54Zm-5.55-10,5.4,1.87,4.31-3.74-1.08-5.6-5.39-1.87L502.81,111Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.68,220.77a5.3,5.3,0,0,1-4.11-2l-3.49-4.36a5.28,5.28,0,0,1-.8-5.2l2-5.2a5.26,5.26,0,0,1,4.1-3.29l5.52-.85a5.29,5.29,0,0,1,4.91,1.91l3.49,4.36a5.28,5.28,0,0,1,.8,5.2l-2,5.2a5.25,5.25,0,0,1-4.11,3.29l-5.52.85A5.16,5.16,0,0,1,680.68,220.77Zm4.05-16.93h-.19l-5.52.85a1.28,1.28,0,0,0-1,.79l-2,5.2a1.26,1.26,0,0,0,.19,1.25l3.49,4.36a1.3,1.3,0,0,0,1.18.46l5.52-.85a1.26,1.26,0,0,0,1-.79l2-5.2a1.28,1.28,0,0,0-.19-1.25h0l-3.49-4.36A1.29,1.29,0,0,0,684.73,203.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7,264.23a6.82,6.82,0,0,1-5.29-2.53l-8.2-10.24a6.78,6.78,0,0,1-1-6.68L48,232.55a6.78,6.78,0,0,1,5.27-4.23l13-2a6.79,6.79,0,0,1,6.3,2.46L80.7,239a6.79,6.79,0,0,1,1,6.69L77,257.93a6.78,6.78,0,0,1-5.28,4.24l-13,2A5.84,5.84,0,0,1,57.7,264.23Zm-7.94-17,8,10,12.7-1.94,4.66-12-8-10-12.7,1.95Zm25.48-3.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88,174.6H83.15A5.27,5.27,0,0,1,78.59,172l-3.87-6.69a5.33,5.33,0,0,1,0-5.27l3.87-6.69a5.26,5.26,0,0,1,4.56-2.63h7.73a5.26,5.26,0,0,1,4.56,2.63L99.31,160a5.33,5.33,0,0,1,0,5.27L95.44,172A5.28,5.28,0,0,1,90.88,174.6Zm-7.73-19.92a1.28,1.28,0,0,0-1.1.63L78.19,162a1.26,1.26,0,0,0,0,1.27L82.05,170a1.29,1.29,0,0,0,1.1.64h7.73A1.29,1.29,0,0,0,92,170l3.86-6.69a1.26,1.26,0,0,0,0-1.27L92,155.31a1.28,1.28,0,0,0-1.1-.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.78 98.95 207.7 89.46 189.19 58.22 163.44 42.46 158.46 47.85 161.07 51.37 169.2 62.27 201.47 105.59 214.63 112.83 222.78 98.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.83 121.41 199.51 107.03 152.09 52.85 145.77 56.59 155.78 85.08 183.31 112.12 189.48 129 203.83 121.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,101.63s53.55,29.39,64.34,39.31,36,51.23,33.44,56.51-4.52,6-10.33.88-24.59-33.42-29.63-38S219.56,119,219.56,119Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.21,
    cy: 97.26,
    r: 16.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,113.67a25.24,25.24,0,0,0,4.14.43,16.2,16.2,0,0,0,4.8-.71,16.79,16.79,0,0,0,12-17.69A15.9,15.9,0,0,0,208.7,91a18.28,18.28,0,0,0-1.08-2.23,17.29,17.29,0,0,0-1.47-2.07,16.62,16.62,0,0,0-19.11-5,19.9,19.9,0,0,0-2.28,1.09,18.59,18.59,0,0,0-2,1.43,15.55,15.55,0,0,0-3.27,3.52,16.81,16.81,0,0,0-2.93,8.32,16.92,16.92,0,0,0,4.75,12.95,16.3,16.3,0,0,0,3.85,3,26,26,0,0,0,3.83,1.64,1.07,1.07,0,0,1-.27,0l-.78-.22a7.71,7.71,0,0,1-1.24-.43,12.11,12.11,0,0,1-1.63-.76,16,16,0,0,1-4-2.93,17.13,17.13,0,0,1-5-13.19,17.22,17.22,0,0,1,3-8.56,16.28,16.28,0,0,1,3.36-3.64,15.9,15.9,0,0,1,4.45-2.61,17.13,17.13,0,0,1,19.69,5.12,19.19,19.19,0,0,1,1.5,2.14,18.09,18.09,0,0,1,1.11,2.31,15.81,15.81,0,0,1,1.16,4.8,17,17,0,0,1-6.53,15.08,16.82,16.82,0,0,1-5.82,2.94,15.8,15.8,0,0,1-4.88.63,11.86,11.86,0,0,1-1.8-.13A8.13,8.13,0,0,1,190,114l-.79-.19A.91.91,0,0,1,189,113.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.81,106.53a9.58,9.58,0,1,1,11.67-6.86A9.58,9.58,0,0,1,190.81,106.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.81,106.53c0-.07.83.2,2.33.2a9.53,9.53,0,0,0,8.54-5.48,9.43,9.43,0,0,0,.82-4.86,9.35,9.35,0,0,0-2.07-5,9.27,9.27,0,0,0-10.66-2.77A8.53,8.53,0,0,0,187.36,90a8.69,8.69,0,0,0-1.83,2,9.46,9.46,0,0,0-1.65,4.64,9.31,9.31,0,0,0,.68,4.26,9.52,9.52,0,0,0,4.11,4.68,20.27,20.27,0,0,0,2.14,1,7.22,7.22,0,0,1-2.24-.79,9.53,9.53,0,0,1-4.35-4.71,9.63,9.63,0,0,1-.77-4.44,9.83,9.83,0,0,1,1.68-4.89A9.33,9.33,0,0,1,187,89.63a9.23,9.23,0,0,1,2.54-1.49,9.75,9.75,0,0,1,11.25,2.92A9.83,9.83,0,0,1,203,96.34a9.83,9.83,0,0,1-.91,5.09,9.69,9.69,0,0,1-2.83,3.5,9.57,9.57,0,0,1-6.1,2A7.14,7.14,0,0,1,190.81,106.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 100.53,
    width: 28.67,
    height: 15.51,
    rx: 7.38,
    transform: "translate(17.68 247.11) rotate(-60.12)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14,110.45a9.92,9.92,0,0,0-.83,2.81,7.69,7.69,0,0,0,.45,3.37,7.87,7.87,0,0,0,1,1.86,7.29,7.29,0,0,0,1.74,1.61,10.72,10.72,0,0,0,2.34,1.19,7.14,7.14,0,0,0,8.07-2.57c2.3-3.83,4.73-8.22,7.35-12.73a7.16,7.16,0,0,0,0-7A7,7,0,0,0,230,96.43a8.64,8.64,0,0,0-3.07-1.36,7.17,7.17,0,0,0-5.87,1.4c-1.57,1.19-2.26,3-3.18,4.46l-4.12,7-1.14,1.89a3.78,3.78,0,0,1-.43.64,6.56,6.56,0,0,1,.34-.7c.27-.48.62-1.13,1.06-1.93,1-1.72,2.31-4.12,4-7.07l1.32-2.34a7.91,7.91,0,0,1,1.91-2.28A7.59,7.59,0,0,1,227,94.6,9.06,9.06,0,0,1,230.22,96a7.41,7.41,0,0,1,2.55,2.69,7.62,7.62,0,0,1,0,7.54c-2.63,4.53-5,8.85-7.41,12.76a7.69,7.69,0,0,1-5.64,3.07,7.79,7.79,0,0,1-2.95-.4,11.23,11.23,0,0,1-2.41-1.28,7.6,7.6,0,0,1-1.81-1.71,8.27,8.27,0,0,1-1-2,7.22,7.22,0,0,1,.26-5.62A4.08,4.08,0,0,1,212.14,110.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,137.54s20.29,57.62,28.33,69.88,44.69,43.84,50.31,42.18,6.61-3.49,2.55-10-29-29.69-32.68-35.42-29.81-73.6-29.81-73.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.87,
    y: 123.77,
    width: 28.67,
    height: 15.51,
    rx: 7.38,
    transform: "translate(-33.47 78.19) rotate(-20.52)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,121.83a3.52,3.52,0,0,1,.72-.28,7.37,7.37,0,0,1,2.21-.28,7.52,7.52,0,0,1,3.38.93,8.35,8.35,0,0,1,1.76,1.35,8,8,0,0,1,1.4,2.06,10.8,10.8,0,0,1,.86,2.59,7.51,7.51,0,0,1-.08,3,7.66,7.66,0,0,1-4,5.06c-4.24,1.71-8.89,3.38-13.79,5.24a7.69,7.69,0,0,1-7.45-1.2,7.6,7.6,0,0,1-2.24-3,9,9,0,0,1-.86-3.44,7.58,7.58,0,0,1,2.52-5.9,7.9,7.9,0,0,1,2.56-1.51l2.52-.93,7.62-2.76,2.08-.73a4.2,4.2,0,0,1,.74-.22,3.33,3.33,0,0,1-.7.32l-2,.82-7.56,2.92c-1.57.67-3.49,1.06-4.92,2.41a7.21,7.21,0,0,0-2.34,5.57,8.81,8.81,0,0,0,.85,3.25,7,7,0,0,0,2.1,2.76,7.16,7.16,0,0,0,6.95,1.11c4.87-1.85,9.6-3.54,13.76-5.18a7.19,7.19,0,0,0,3.85-7.54,10.69,10.69,0,0,0-.81-2.51,7.47,7.47,0,0,0-1.3-2,7.7,7.7,0,0,0-1.66-1.32,7.45,7.45,0,0,0-3.25-1A9.69,9.69,0,0,0,203,121.83Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.76,453.47c0,.14-152.44.26-340.44.26s-340.47-.12-340.47-.26,152.41-.26,340.47-.26S714.76,453.33,714.76,453.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,339.07c.27-.84,31.43-102.7,31.43-102.7l-.78-12.65,8.15-13.42,10.12,3.35-1.38,15-7.2,10.94L96,342Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,339.07l.6.17,1.73.54L96,341.87l-.11.06c5.07-16.61,16.79-55.05,31.23-102.38v0l0,0,7.19-10.93,0,.11c.44-4.79.91-9.88,1.38-15l.18.27-.84-.27-9.28-3.07.3-.11-8.15,13.42,0-.15q.39,6.47.77,12.65v.09c-9.11,29.59-17,55.22-22.61,73.46-2.82,9.13-5.08,16.4-6.63,21.41-.77,2.5-1.38,4.43-1.79,5.75l-.47,1.49-.17.51a4.43,4.43,0,0,1,.13-.49c.1-.35.24-.84.43-1.47.4-1.32,1-3.24,1.72-5.72,1.51-5,3.71-12.28,6.47-21.4,5.58-18.3,13.4-44,22.44-73.69v.09q-.39-6.18-.79-12.65v-.08l0-.07,8.15-13.42.1-.18.2.07,9.29,3.06.83.28.2.06,0,.21c-.47,5.15-.94,10.24-1.39,15v.07l0,.05-7.19,10.94,0-.07C113,287,101.18,325.39,96.06,342l0,.09-.09,0-6.68-2.21-1.69-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49,344l-14,18.92-19.57,71s-2.81,14.48,13.18,18.59c18,4.62,22.1-9.14,22.1-9.14l19-69.33L100,350l4.69-5.29a2,2,0,0,0-.85-3.19l-22.48-7.42a2,2,0,0,0-2.59,2.07Z",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,350.83c-.05.14-4.76-1.23-10.52-3.06s-10.41-3.43-10.36-3.57,4.75,1.24,10.52,3.07S100.16,350.69,100.12,350.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24,374.05a6.67,6.67,0,0,1-1.4-.24c-.9-.19-2.18-.5-3.77-.9-3.18-.79-7.54-2-12.29-3.52s-9-3.06-12.07-4.25c-1.52-.6-2.75-1.1-3.59-1.46a7.13,7.13,0,0,1-1.28-.61,7.28,7.28,0,0,1,1.36.42l3.64,1.3c3.08,1.1,7.34,2.59,12.09,4.1s9.09,2.78,12.23,3.67l3.73,1.05A7.75,7.75,0,0,1,100.24,374.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 368.79,
    width: 7.11,
    height: 68.49,
    rx: 3.3,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 116.98, -1.15)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.88,
    y: 372.07,
    width: 7.11,
    height: 68.49,
    rx: 3.3,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 118.35, -3.84)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 375.21,
    width: 7.11,
    height: 68.49,
    rx: 3.3,
    transform: "translate(119.66 -6.72) rotate(16.49)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,239.6a20.88,20.88,0,0,1-4.46-1.27,20,20,0,0,1-4.28-1.76,21.62,21.62,0,0,1,4.45,1.27A20.26,20.26,0,0,1,127.27,239.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.94,213.65a8.12,8.12,0,0,1-.35,1.4c-.29,1-.67,2.26-1.14,3.82l-4,13-.08.25-.25-.08-4.61-1.61-4.74-1.66-.23-.08.07-.23c1.44-5.14,2.71-9.65,3.65-13,.46-1.55.83-2.83,1.12-3.79a9.16,9.16,0,0,1,.46-1.36,8.12,8.12,0,0,1-.29,1.41l-1,3.83c-.89,3.33-2.09,7.85-3.47,13l-.16-.31,4.75,1.66,4.6,1.61-.33.17,4.2-12.91c.52-1.55,1-2.81,1.28-3.77A8.57,8.57,0,0,1,135.94,213.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.9,111.92a7.15,7.15,0,0,1-2.37-.4l-12.25-4.24a7.29,7.29,0,0,1-4.75-5.49l-2.45-12.73a7.26,7.26,0,0,1,2.38-6.86l9.8-8.48a7.28,7.28,0,0,1,7.13-1.37l12.24,4.24a7.29,7.29,0,0,1,4.76,5.49l2.45,12.73a7.31,7.31,0,0,1-2.38,6.86l-9.8,8.48A7.28,7.28,0,0,1,430.9,111.92ZM419.3,99.86l11.45,4,9.15-7.92L437.61,84l-11.44-4L417,88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.9,111.92a7.15,7.15,0,0,1-2.37-.4l-12.25-4.24a7.29,7.29,0,0,1-4.75-5.49l-2.45-12.73a7.26,7.26,0,0,1,2.38-6.86l9.8-8.48a7.28,7.28,0,0,1,7.13-1.37l12.24,4.24a7.29,7.29,0,0,1,4.76,5.49l2.45,12.73a7.31,7.31,0,0,1-2.38,6.86l-9.8,8.48A7.28,7.28,0,0,1,430.9,111.92ZM419.3,99.86l11.45,4,9.15-7.92L437.61,84l-11.44-4L417,88Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.3,99.86a6.36,6.36,0,0,1-.2-.79l-.5-2.35c-.43-2.11-1-5.08-1.77-8.71a.2.2,0,0,1,.06-.19l9.12-8a.26.26,0,0,1,.24,0l11.44,4,.18.2h0v.17l0,.2.08.39.15.78c.1.51.19,1,.29,1.54.2,1,.39,2,.58,3,.38,2,.75,3.92,1.1,5.77a.24.24,0,0,1-.08.23L430.87,104a.19.19,0,0,1-.19,0l-8.37-3-2.25-.84a5.66,5.66,0,0,1-.76-.31,6.07,6.07,0,0,1,.84.24l2.31.74,8.36,2.8-.19,0,9.12-8-.08.24c-.36-1.86-.74-3.78-1.12-5.77-.19-1-.39-2-.59-3-.1-.51-.19-1-.29-1.54l-.15-.78-.08-.39,0-.2,0-.1v-.07h0s.32.37.16.19l-11.43-4,.24,0-9.19,7.89.07-.19c.65,3.62,1.19,6.57,1.57,8.68.17,1,.31,1.79.41,2.39A4.79,4.79,0,0,1,419.3,99.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.9,111.92s.43,0,1.24-.16a7.28,7.28,0,0,0,3.19-1.47l9.95-8.71A7.1,7.1,0,0,0,447.51,98a7.34,7.34,0,0,0,.24-2.25,21,21,0,0,0-.4-2.35c-.63-3.23-1.3-6.67-2-10.29a10.15,10.15,0,0,0-.73-2.63,7,7,0,0,0-4-3.67l-2.82-1-5.79-2-3-1a8.06,8.06,0,0,0-3-.63,7.11,7.11,0,0,0-3,.66,9.88,9.88,0,0,0-2.48,1.77l-4.63,4-4.47,3.87a7.06,7.06,0,0,0-2.28,4.82,10.37,10.37,0,0,0,.3,2.65c.17.89.33,1.76.5,2.62.32,1.72.64,3.38.94,5s.59,3.18.9,4.64a7.15,7.15,0,0,0,2.24,3.56,7.28,7.28,0,0,0,1.67,1.07c.59.26,1.22.45,1.8.67l3.35,1.18,5.36,1.9a28.56,28.56,0,0,0,3.4,1.13c.8.15,1.24.14,1.24.16a5.23,5.23,0,0,1-1.26,0,25.7,25.7,0,0,1-3.44-1.05L420.81,109l-3.36-1.14c-.6-.21-1.21-.39-1.84-.66a7.7,7.7,0,0,1-1.77-1.11,7.51,7.51,0,0,1-2.39-3.73c-.34-1.52-.61-3.06-.93-4.67s-.64-3.28-1-5q-.26-1.27-.51-2.61a10.76,10.76,0,0,1-.32-2.76,7.57,7.57,0,0,1,2.43-5.17l4.46-3.88,4.63-4c.4-.34.77-.68,1.2-1a8.24,8.24,0,0,1,1.4-.84,7.53,7.53,0,0,1,3.18-.7,8.59,8.59,0,0,1,3.17.66l3,1,5.79,2,2.82,1a7.56,7.56,0,0,1,2.57,1.55,7.42,7.42,0,0,1,1.73,2.38,10.47,10.47,0,0,1,.76,2.75q1,5.45,1.95,10.3a19.51,19.51,0,0,1,.39,2.41,7.51,7.51,0,0,1-2.64,6.1l-10.06,8.59a7.37,7.37,0,0,1-3.31,1.42A5.14,5.14,0,0,1,430.9,111.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,91.1a5.27,5.27,0,0,1-4.12-2l-3.49-4.35a5.3,5.3,0,0,1-.8-5.21l2-5.2a5.27,5.27,0,0,1,4.11-3.29l5.51-.85a5.29,5.29,0,0,1,4.91,1.91l3.49,4.36a5.28,5.28,0,0,1,.8,5.2l-2,5.21A5.29,5.29,0,0,1,352,90.2l-5.52.84A5.35,5.35,0,0,1,345.67,91.1Zm4-16.93-.19,0L344,75a1.28,1.28,0,0,0-1,.79L341,81a1.28,1.28,0,0,0,.19,1.25l3.49,4.35a1.28,1.28,0,0,0,1.18.46l5.52-.85a1.27,1.27,0,0,0,1-.79l2-5.2a1.26,1.26,0,0,0-.19-1.25l-3.49-4.35A1.28,1.28,0,0,0,349.71,74.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,91.1a5.27,5.27,0,0,1-4.12-2l-3.49-4.35a5.3,5.3,0,0,1-.8-5.21l2-5.2a5.27,5.27,0,0,1,4.11-3.29l5.51-.85a5.29,5.29,0,0,1,4.91,1.91l3.49,4.36a5.28,5.28,0,0,1,.8,5.2l-2,5.21A5.29,5.29,0,0,1,352,90.2l-5.52.84A5.35,5.35,0,0,1,345.67,91.1Zm4-16.93-.19,0L344,75a1.28,1.28,0,0,0-1,.79L341,81a1.28,1.28,0,0,0,.19,1.25l3.49,4.35a1.28,1.28,0,0,0,1.18.46l5.52-.85a1.27,1.27,0,0,0,1-.79l2-5.2a1.26,1.26,0,0,0-.19-1.25l-3.49-4.35A1.28,1.28,0,0,0,349.71,74.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.71,74.17a.72.72,0,0,1,.43,0,1.2,1.2,0,0,1,.47.25,6.51,6.51,0,0,1,.48.53l2.84,3.41.46.57a1.44,1.44,0,0,1,.28.81,2,2,0,0,1-.2.83c-.09.25-.19.5-.28.76-.4,1-.82,2.13-1.26,3.29-.11.29-.22.58-.34.88a1.5,1.5,0,0,1-.74.83,3.94,3.94,0,0,1-1,.23l-1,.16c-1.35.2-2.67.43-4.17.62a1.52,1.52,0,0,1-1.14-.51l-.66-.83-1.29-1.6-1.23-1.56-.31-.38a1.67,1.67,0,0,1-.28-.47,1.54,1.54,0,0,1,0-1.1l1.3-3.27.59-1.48a3.55,3.55,0,0,1,.34-.72,1.42,1.42,0,0,1,.64-.5c1.92-.35,3.38-.49,4.43-.63a7.61,7.61,0,0,1,1.63-.14,1.82,1.82,0,0,1-.41.1l-1.18.24c-1,.2-2.58.42-4.33.77a1.15,1.15,0,0,0-.47.38,4.07,4.07,0,0,0-.28.65l-.56,1.49-1.26,3.29a1.07,1.07,0,0,0,0,.75,3.42,3.42,0,0,0,.51.71L343,84.1l1.29,1.6.65.81a1,1,0,0,0,.75.33l4.09-.61,1-.15a3.32,3.32,0,0,0,.89-.18,1,1,0,0,0,.51-.56c.11-.3.23-.59.34-.88.46-1.14.89-2.24,1.3-3.27q.17-.37.3-.75a1.71,1.71,0,0,0,.19-.67,1.22,1.22,0,0,0-.19-.6l-.44-.56-2.71-3.51A1.69,1.69,0,0,0,349.71,74.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,91.1a4.58,4.58,0,0,1,.66-.1l1.91-.33,3-.51a7.31,7.31,0,0,0,1.82-.44,5,5,0,0,0,1.7-1.16A5.29,5.29,0,0,0,356,86.62c.29-.76.6-1.56.91-2.39.55-1.67,1.67-3.38,1.26-5.29a5.31,5.31,0,0,0-1.28-2.6l-2-2.48-1-1.28a5.76,5.76,0,0,0-1.12-1.14,5,5,0,0,0-3-1,10.83,10.83,0,0,0-1.66.19l-1.67.25-3.25.51a5,5,0,0,0-2.6,1.48,5.19,5.19,0,0,0-.84,1.2c-.21.43-.38.93-.56,1.38l-1.07,2.71a14.24,14.24,0,0,0-.88,2.54,5.27,5.27,0,0,0,1.37,4.39l2.51,3.2c.38.46.69.92,1.05,1.27a5.18,5.18,0,0,0,1.09.82,6.35,6.35,0,0,0,2.47.72s-.06,0-.18,0-.28,0-.5,0a5.07,5.07,0,0,1-1.88-.55,5.82,5.82,0,0,1-1.17-.82,16,16,0,0,1-1.11-1.27l-2.57-3.15a5.62,5.62,0,0,1-1.5-4.68,13.93,13.93,0,0,1,.87-2.65l1.05-2.71c.19-.47.34-.93.57-1.42a5.71,5.71,0,0,1,.91-1.33A5.6,5.6,0,0,1,343,70.89c1.1-.19,2.17-.34,3.28-.52l1.67-.25a10.51,10.51,0,0,1,1.74-.2A5.46,5.46,0,0,1,353,71a6.12,6.12,0,0,1,1.21,1.23l1,1.28c.68.84,1.34,1.68,2,2.49a5.69,5.69,0,0,1,1.37,2.83,5.46,5.46,0,0,1-.32,3c-.34.87-.68,1.72-1,2.55s-.64,1.61-.94,2.38a5.55,5.55,0,0,1-1.29,2,5.87,5.87,0,0,1-3.75,1.63l-3,.42c-.83.11-1.48.2-1.92.23A2.92,2.92,0,0,1,345.67,91.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.09,78.05a15.17,15.17,0,0,1-2.58,3.29,12.46,12.46,0,0,1-3.15,2.77A27.3,27.3,0,0,1,440.13,81,18.49,18.49,0,0,1,443.09,78.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,72.3a11.93,11.93,0,0,1,1.33,3.78,11.78,11.78,0,0,1,.53,4,22.26,22.26,0,0,1-1-3.86A21.83,21.83,0,0,1,424.34,72.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.88,87.77a23.61,23.61,0,0,1-3.84-1.1,25.2,25.2,0,0,1-3.8-1.26,18.4,18.4,0,0,1,7.64,2.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,105.12a12,12,0,0,1,2-2.86,12.26,12.26,0,0,1,2.44-2.52,11.48,11.48,0,0,1-2,2.86A12.26,12.26,0,0,1,414.75,105.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,110.59a10.4,10.4,0,0,1-.7-3.22,10.29,10.29,0,0,1-.19-3.3,10.72,10.72,0,0,1,.7,3.23A10.58,10.58,0,0,1,431.59,110.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.82,97.78a9.22,9.22,0,0,1-2.95-.86,9,9,0,0,1-2.77-1.34,18.44,18.44,0,0,1,5.72,2.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.34,174.46c6.77-8.16,13.54-16.4,18.82-25.6s9-19.48,9.27-30.08c0-1.61-.65-12.76-2.2-13.21-1.1-.32-1.86,9.53-2.76,10.24-8.64,6.76-14.25,16.79-17.48,27.27a143.85,143.85,0,0,0-5.65,31.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.15,236.48c2.7-7,16-42,15.93-42s-22.91-11.92-15-36.2c3.8-11.73,13.59-35.24,22.69-56.42a47.55,47.55,0,0,1,58.89-26.25l2.33.79c24.66,10,30,36.47,19.33,60.84l-49,113.5-42.94-13.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.09,194.5s14.93,6,34.61,1.32c0,0-13.62,15.39-37,5.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.73,125.23a3.65,3.65,0,0,0,2.15,4.61,3.49,3.49,0,0,0,4.61-1.91,3.64,3.64,0,0,0-2.15-4.61A3.48,3.48,0,0,0,579.73,125.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.51,113.66c.28.6,3.55-.46,7.26.81s5.81,4,6.36,3.72c.27-.13.11-1.09-.79-2.36a9.94,9.94,0,0,0-4.9-3.53,9.56,9.56,0,0,0-6-.08C582,112.71,581.37,113.39,581.51,113.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.32,138.34a3.63,3.63,0,0,0,2.15,4.6,3.48,3.48,0,0,0,4.61-1.91,3.65,3.65,0,0,0-2.15-4.61A3.49,3.49,0,0,0,612.32,138.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.4,127.45c.27.6,3.55-.45,7.26.81s5.8,4,6.36,3.73c.26-.14.11-1.1-.79-2.36a10,10,0,0,0-4.91-3.54,9.53,9.53,0,0,0-6-.08C617.92,126.5,617.26,127.18,617.4,127.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,151.5c.09-.2-2.09-1.38-5.67-3.12-.91-.42-1.75-.91-1.69-1.62s.75-1.65,1.58-2.59l5.25-6.28c7.37-9,13.05-16.47,12.68-16.77s-6.63,6.74-14,15.71c-1.79,2.22-3.51,4.33-5.14,6.36-.72,1-1.75,2-1.75,3.56a2.53,2.53,0,0,0,1.09,1.91,7.11,7.11,0,0,0,1.54.77C592,150.9,594.34,151.71,594.43,151.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.5,157.76c-.6-.23-2,3.8-6.38,5.49s-8.57-.19-8.79.36c-.14.23.7,1.1,2.49,1.77a10.67,10.67,0,0,0,7.26-.07,9.25,9.25,0,0,0,5.09-4.69C604.89,159,604.78,157.83,604.5,157.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.69,112.45c0,1.13,3.9,1.91,8.08,3.9s7.31,4.38,8.19,3.67c.4-.35.11-1.51-1-3a15.55,15.55,0,0,0-12.39-5.77C623.77,111.39,622.7,111.92,622.69,112.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.22,101.83c.37,1.07,3.22,1,6.31,2s5.5,2.49,6.39,1.81c.41-.34.29-1.32-.58-2.51a9.63,9.63,0,0,0-10.24-3.11C587.72,100.57,587.07,101.32,587.22,101.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.26,154.5c.48,0,18.27.69,12.17,17s-21.27,6.85-21.12,6.37S652.26,154.5,652.26,154.5Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.62,173.58c.09,0,.21.31.61.71a3,3,0,0,0,2.11.84c2,0,4.44-2.19,5.62-5.11a10,10,0,0,0,.73-4.38,3.48,3.48,0,0,0-1.33-3,1.54,1.54,0,0,0-2,.15c-.39.38-.41.74-.5.74s-.25-.41.13-1a2,2,0,0,1,1-.79,2.31,2.31,0,0,1,1.73.17,4.29,4.29,0,0,1,2,3.65,10.43,10.43,0,0,1-.72,4.93c-1.34,3.25-4.17,5.71-6.79,5.51a3.3,3.3,0,0,1-2.45-1.41C650.5,174,650.55,173.59,650.62,173.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.64,78.93c-2.08-2.46,9.11-8,16.72-8.42,11.5-.68,27.51,2.32,35.55,8.35,9.7,7.25,16.65,16.13,18.31,28.12s-.71,24.31-5.36,35.49c-1.42,3.41-3.16,6.86-6.12,9.07-3.65,2.73-8.89,3.32-10.61,8.37a7.3,7.3,0,0,1-3.6,4.32c-4.2,2-6.7-2.35-7.23-6-1.13-7.76,1.39-15.53,3.88-23,1.77-5.28,3.6-10.67,7-15.1,1.84-2.41,4.1-4.48,5.81-7s2.82-5.67,2-8.58a10.31,10.31,0,0,0-.81-1.85,18.21,18.21,0,0,0-15.62-9.68c-10.43-.27-28-1.44-30.85-6.12-4.17-6.74-4.46-10.2-4.46-10.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655,68.88c1.05.53,25.62,15.71,25.46,37.85s-4.21,27.56-4.21,27.56a13.62,13.62,0,0,1,2,3.35c.66,1.68-3.11,7.38-6.34,5.48-22.06-20.47-52.46-32.23-87.14-43l-26.16-9.37c-7.66-1.67-9.57-4.52-5.83-5.29,2.87-.6,26.63-1.8,26.63-1.8l5.13-1.58,16-11.31s-.62-2.56,2.63-3.39S634.34,58.38,655,68.88Z",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.52,82.12s.35.14,1,.36l3,.94c2.58.77,6.25,2.07,10.77,3.73A215.13,215.13,0,0,1,633,103.63a329.88,329.88,0,0,1,31,21.26c3.84,2.91,6.89,5.33,9,7l2.45,1.91c.56.43.87.64.87.64s-.27-.26-.82-.72l-2.39-2c-2.09-1.7-5.12-4.16-8.93-7.1a307.34,307.34,0,0,0-31-21.4,205.4,205.4,0,0,0-33.88-16.39A154.54,154.54,0,0,0,584.52,82.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M675.34,89s-27.12-14.52-42.1-12.76L635,76l-14,1.16c-2.37.2-5.08.27-6.7-1.46,0,0,8.49-3.6,21.9-3.53S669.29,77,675.34,89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M675.7,89.24a21.84,21.84,0,0,0-2-2.57,37.91,37.91,0,0,0-6.58-5.94,44.73,44.73,0,0,0-11.69-6,37.67,37.67,0,0,0-15.91-2.21,66.18,66.18,0,0,0-8.24,1.36c-2.62.59-5.17,1-7.58,1.7a40.67,40.67,0,0,1-6.78,1.62,13.1,13.1,0,0,1-5.94-.79c-7.09-2.33-10.92-5.28-10.44-5.61a1.16,1.16,0,0,0,.37.75A9.49,9.49,0,0,0,602.83,73a41.17,41.17,0,0,0,8.06,3.71,13.56,13.56,0,0,0,6.08.86A40.91,40.91,0,0,0,623.83,76c2.36-.65,4.94-1.09,7.56-1.68A70.14,70.14,0,0,1,639.57,73a37.91,37.91,0,0,1,15.73,2.15A45.76,45.76,0,0,1,666.94,81a40.15,40.15,0,0,1,6.63,5.79c.71.77,1.24,1.39,1.58,1.82S675.7,89.24,675.7,89.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M680.14,115.88c-5.14-1.81-8.58-4.48-13.31-7.36-5-3.06-10.11-5.86-15-9.16-3.71-2.5-8.2-5.14-9.85-9a6.29,6.29,0,0,0-.09,6.19c1.05,2,5.5,5.57,7.4,6.86,10.81,7.35,18.32,12.37,30.4,17.48a37.75,37.75,0,0,0,.44-5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M680.4,104.28c2.78,2.53,4.45,4.17,3.59,7-.71,2.34-2.15,5-4.57,4.63a5.9,5.9,0,0,1-2-.88L644.3,95.64A5.49,5.49,0,0,1,641.56,93c-.66-1.88,1-3.94,2.91-4.46s3.95,0,5.85.66c10.78,3.49,20.61,8.85,30.08,15.07",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.92,93.72a3.67,3.67,0,0,1-.42-1.88,4.71,4.71,0,0,1,3-4c2.12-.72,4.93-.24,7.69.88s5.87,2.39,9,3.84a100,100,0,0,1,15.57,8.64c1.88,1.29,3.33,2.43,4.34,3.22l1.14.93a2.42,2.42,0,0,0,.42.3s-.11-.14-.36-.37l-1.09-1c-1-.83-2.39-2-4.26-3.35a91.47,91.47,0,0,0-15.57-8.79c-3.18-1.46-6.25-2.72-9.07-3.83s-5.71-1.59-8-.78a4.87,4.87,0,0,0-3.06,4.29,3.16,3.16,0,0,0,.31,1.45A1.66,1.66,0,0,0,641.92,93.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.52 74.36 618.03 81.57 613.98 87.22 589.85 78.36 595.52 74.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.52,105.81c.05-.12-9.42-5-21.17-10.82S580,84.46,580,84.58s9.42,5,21.17,10.82S622.46,105.92,622.52,105.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.19,227.13l.3-14.78-50.58,18.79s-9.35-30.37-9.35-31.8l-11.21,7-18.63-8-18.63-9.2-37.68,66L442.88,371.68,536,433.8l69.06-74,42-64,23.08-40.52Z",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.41,230.92a10.13,10.13,0,0,1-.07-1.48c0-1,0-2.42-.06-4.14l.23.14a63.37,63.37,0,0,0-15.23,10.43l-.4.38,0-.55c0-.66-.08-1.36-.12-2.07-.41-7.25-.75-13.81-1-18.57-.1-2.32-.18-4.22-.24-5.63q0-.92,0-1.53a.27.27,0,1,1,.1,0c0,.4.08.91.14,1.52.1,1.41.23,3.31.39,5.62.32,4.75.71,11.31,1.12,18.56,0,.71.08,1.41.11,2.07l-.43-.18a59.76,59.76,0,0,1,15.44-10.34l.24-.1v.25c0,1.72-.07,3.11-.09,4.14A10.08,10.08,0,0,1,573.41,230.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.53,227.84a2.83,2.83,0,0,1-.58.31l-1.69.81L615,231.83l-20.76,9.28-9.86,4.36-.42.18.08-.45A77.72,77.72,0,0,0,585.18,231l.23.14-4.67,2.27-1.25.58c-.28.13-.43.19-.44.17a1.89,1.89,0,0,1,.4-.25l1.21-.66,4.61-2.4.22-.12V231a72.66,72.66,0,0,1-1,14.33l-.34-.27,9.85-4.38,20.82-9.15,6.34-2.72,1.73-.71A2.82,2.82,0,0,1,623.53,227.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.63,
    y: 153.88,
    width: 410.04,
    height: 292.88,
    rx: 14.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6,427.84H567.85a0,0,0,0,1,0,0v7.83a17.8,17.8,0,0,1-17.8,17.8H141.4a17.8,17.8,0,0,1-17.8-17.8v-7.83a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.64,
    y: 165.52,
    width: 386.88,
    height: 247.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.23 425.1 309.74 434.57 387.31 434.57 392.43 425.1 304.23 425.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.6,
    y: 173.89,
    width: 371.74,
    height: 238.16,
    rx: 3.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.95 412.4 158.21 412.4 158.6 191.69 529.95 191.69 529.95 412.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,183.09a3.06,3.06,0,1,1-3.06-3.21A3.14,3.14,0,0,1,189.84,183.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,183.09a3.06,3.06,0,1,1-3.06-3.21A3.14,3.14,0,0,1,171.28,183.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,183.09a3.06,3.06,0,1,1-3.06-3.21A3.14,3.14,0,0,1,180.82,183.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.15,425.1c0,.16-91,.28-203.25.28s-203.27-.12-203.27-.28,91-.29,203.27-.29S546.15,424.94,546.15,425.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.54,234a79.31,79.31,0,0,1,19.34-8.4l4-19.15,32.34-.57,4.66,19a79.63,79.63,0,0,1,19.62,7.72l16.35-10.71,23.27,22.47L414,261.09a79.21,79.21,0,0,1,8.4,19.35l19.14,4,.57,32.34-19,4.66A79.24,79.24,0,0,1,415.38,341l10.72,16.35-22.47,23.27-16.71-10.13a79.21,79.21,0,0,1-19.35,8.4l-4,19.15-32.35.56-4.65-19A79.09,79.09,0,0,1,307,371.93l-16.35,10.72-23.27-22.47,10.13-16.71a79.24,79.24,0,0,1-8.41-19.35l-19.14-4-.57-32.34,19-4.66a79.47,79.47,0,0,1,7.72-19.62l-10.71-16.35,22.47-23.27L304.54,234Zm17.24,43.09a34.7,34.7,0,1,0,49.07-.86A34.7,34.7,0,0,0,321.78,277.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.75,246.37a27.69,27.69,0,0,1,2.25-6.91l-4-5.4,7.24-8.48,6,3.14a27.37,27.37,0,0,1,6.47-3.29l1-6.67,11.11-.87,2,6.43a27.31,27.31,0,0,1,6.91,2.26l5.4-4,8.48,7.25-3.14,6a27.28,27.28,0,0,1,3.3,6.48l6.66,1,.87,11.12-6.43,2a27.05,27.05,0,0,1-2.26,6.91l4,5.41-7.24,8.47-6-3.14a27.28,27.28,0,0,1-6.48,3.3l-1,6.67-11.11.87-2-6.44a27.29,27.29,0,0,1-6.91-2.25l-5.41,4L435,272.9l3.14-6a27.47,27.47,0,0,1-3.3-6.48l-6.66-1-.87-11.12,6.43-2Zm15.07,3.37a12,12,0,1,0,9.84-10.68A12,12,0,0,0,448.82,249.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,358a32,32,0,0,1,1.39-8.47L185.94,344l6.94-11.18,7.52,2.6a32.34,32.34,0,0,1,7-5l-.06-7.95,12.82-3,3.47,7.15a31.93,31.93,0,0,1,8.47,1.39l5.59-5.67,11.18,6.94-2.6,7.52a32.34,32.34,0,0,1,5,7l7.95-.06,3,12.81L255.06,360a32.42,32.42,0,0,1-1.4,8.47l5.67,5.58-6.94,11.19-7.52-2.6a32.1,32.1,0,0,1-7,5l.06,7.95-12.81,3-3.48-7.15A32,32,0,0,1,213.2,390l-5.58,5.67-11.19-6.94,2.6-7.52a32.34,32.34,0,0,1-5-7l-8,.06-3-12.81,7.15-3.48Zm18.53,3.6a14.12,14.12,0,1,0,10.53-17A14.12,14.12,0,0,0,208.75,361.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,251.18a20.14,20.14,0,0,1,1.7-5.21l-3-4.08,5.46-6.39,4.5,2.37a20.79,20.79,0,0,1,4.88-2.49l.74-5,8.38-.66,1.5,4.85a20.93,20.93,0,0,1,5.21,1.7l4.08-3,6.38,5.46-2.36,4.5a20.38,20.38,0,0,1,2.48,4.88l5,.73.66,8.38L254,258.68a20.77,20.77,0,0,1-1.69,5.21l3,4.07-5.46,6.39-4.5-2.37a20.41,20.41,0,0,1-4.88,2.49l-.73,5-8.38.65-1.51-4.85a20.27,20.27,0,0,1-5.21-1.7l-4.07,3-6.39-5.46,2.36-4.5a20.38,20.38,0,0,1-2.48-4.88l-5-.74-.65-8.38,4.85-1.5Zm11.35,4.07a9,9,0,1,0,8.29-9.69A9,9,0,0,0,224.58,255.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.17,341.43a18.09,18.09,0,0,1,1.46-4.48l-2.61-3.5,4.69-5.49,3.87,2a17.62,17.62,0,0,1,4.19-2.14l.63-4.32,7.2-.56,1.29,4.17a17.68,17.68,0,0,1,4.48,1.46l3.5-2.61,5.49,4.69-2,3.86a17.69,17.69,0,0,1,2.14,4.2l4.32.63.56,7.2-4.17,1.29a17.68,17.68,0,0,1-1.46,4.48l2.61,3.5-4.69,5.48-3.86-2a18.07,18.07,0,0,1-4.2,2.14l-.63,4.31-7.2.56-1.29-4.16a18.09,18.09,0,0,1-4.48-1.46l-3.5,2.61L435,358.6l2-3.86a17.62,17.62,0,0,1-2.14-4.19l-4.31-.63-.57-7.2,4.17-1.29Zm9.75,3.49A7.75,7.75,0,1,0,451,336.6,7.74,7.74,0,0,0,443.92,344.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.73,352.28H296a16.7,16.7,0,0,1-14.45-25l24.88-43.09,24.87-43.09a16.7,16.7,0,0,1,28.91,0l24.88,43.09,24.88,43.09a16.7,16.7,0,0,1-14.46,25Z",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.29,332.22s.13.25.38.77a6.84,6.84,0,0,1-.66,6.42,6.75,6.75,0,0,1-1.87,1.86,6.1,6.1,0,0,1-2.86.94c-8.48.09-20.72.07-35.86.11l-53.18.06h-7.6a6.55,6.55,0,0,1-6.13-4.44,7.14,7.14,0,0,1-.25-4c.08-.33.19-.66.3-1s.29-.63.44-.93l1-1.75c1.28-2.35,2.58-4.71,3.88-7.1L313,293.57,329.22,264q3.91-7.17,7.7-14.07c.64-1.14,1.23-2.29,1.91-3.42a7.69,7.69,0,0,1,2.8-2.78,8.23,8.23,0,0,1,7.52-.34,7.87,7.87,0,0,1,3,2.38A30,30,0,0,1,354,249c1.17,2.14,2.33,4.25,3.46,6.33q3.42,6.24,6.61,12.11c4.27,7.81,8.24,15.09,11.86,21.73,7.24,13.29,13.09,24.05,17.14,31.5l4.64,8.57c.52,1,.92,1.72,1.19,2.24s.4.77.4.77-.16-.25-.44-.75l-1.24-2.21-4.73-8.53c-4.08-7.43-10-18.15-17.28-31.41l-11.91-21.71-6.64-12.09c-1.14-2.08-2.29-4.19-3.47-6.33a32.22,32.22,0,0,0-1.83-3.14,7.44,7.44,0,0,0-2.8-2.23,7.74,7.74,0,0,0-7.08.32,7.31,7.31,0,0,0-2.62,2.62c-.66,1.09-1.26,2.26-1.89,3.4l-7.7,14.07c-5.22,9.56-10.64,19.45-16.18,29.59l-16.19,29.57c-1.31,2.39-2.6,4.76-3.89,7.1a14.9,14.9,0,0,0-1.65,3.54,6.65,6.65,0,0,0,.23,3.75,6,6,0,0,0,5.66,4.11h7.6l53.18.05,35.85.05a5.89,5.89,0,0,0,2.77-.88,6.63,6.63,0,0,0,1.85-1.8,6.82,6.82,0,0,0,1.18-3.84A7.53,7.53,0,0,0,399.29,332.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,323c0-4.41,3.52-7.7,8.53-7.7s8.45,3.29,8.45,7.7-3.44,7.85-8.45,7.85S337.67,327.35,337.67,323Zm.08-45.17h16.9l-2.84,33.28H340.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.11,236.12a13.5,13.5,0,0,0-3.16-.66,11.26,11.26,0,0,0-7.22,2.42A17.9,17.9,0,0,0,333,244c-.91,1.8-1.34,3-1.42,2.95a3,3,0,0,1,.21-.86,21,21,0,0,1,.88-2.25,16.85,16.85,0,0,1,4.77-6.38A11,11,0,0,1,345,235.1a7.41,7.41,0,0,1,2.37.58C347.86,235.91,348.13,236.09,348.11,236.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,254.4A6.89,6.89,0,0,1,328.4,252c.73-1.23,1.42-2.17,1.55-2.1a6.8,6.8,0,0,1-1.1,2.36A6.89,6.89,0,0,1,327.31,254.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "370.69 259.26 293.2 307 283.14 324.44 376.16 268.73 370.69 259.26",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.89,280.42,280.18,341a11,11,0,0,0,2.23,4.32L384.7,283.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M636.72,393.4a30.26,30.26,0,0,0-31.65-8.48l-9.57-10.5-1.33-1.49-75.73-83.09a30.25,30.25,0,0,0-32-41.94l-3.7,1.47L495.61,258l-.69,14.05-10.41,9.45-14.05-.69-9.18-10.12-3.79,1.49c-1.09,8.47,4.59,19.15,10.78,26a30.24,30.24,0,0,0,31.6,8.49l77,84.48,2.36,2.63,7.3,8A30.22,30.22,0,0,0,591.92,434c6.16,6.8,14.34,11.34,22.85,11.11l3.8-1.48-9.19-10.13.69-14,10.41-9.45,14,.68,5.38,11.61,3.8-1.49A30.23,30.23,0,0,0,636.72,393.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M636.72,393.4a30.26,30.26,0,0,0-31.65-8.48l-9.57-10.5-1.33-1.49-75.73-83.09a30.25,30.25,0,0,0-32-41.94l-3.7,1.47L495.61,258l-.69,14.05-10.41,9.45-14.05-.69-9.18-10.12-3.79,1.49c-1.09,8.47,4.59,19.15,10.78,26a30.24,30.24,0,0,0,31.6,8.49l77,84.48,2.36,2.63,7.3,8A30.22,30.22,0,0,0,591.92,434c6.16,6.8,14.34,11.34,22.85,11.11l3.8-1.48-9.19-10.13.69-14,10.41-9.45,14,.68,5.38,11.61,3.8-1.49A30.23,30.23,0,0,0,636.72,393.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M632.92,394.88a30.23,30.23,0,0,0-31.64-8.47L591.7,375.9l-1.33-1.49-75.73-83.09a30.24,30.24,0,0,0-32-41.93l9.18,10.12-.68,14L480.71,283l-14-.68-9.18-10.12a30.23,30.23,0,0,0,38.58,35.94l77,84.48,2.37,2.63,7.3,8a30.24,30.24,0,0,0,32,41.89L605.59,435l.68-14,10.42-9.45,14,.69,9.18,10.12A30.19,30.19,0,0,0,632.92,394.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.92,394.88s.44.48,1.27,1.45a31.63,31.63,0,0,1,3.13,4.72,30.26,30.26,0,0,1,2.7,21.31l0,.2-.14-.15-9.19-10.11.08.05-14-.67.1,0-10.4,9.46,0-.11c-.2,4.36-.43,9.11-.67,14.05l0-.13L614.91,445l.24.26-.35.05A30.35,30.35,0,0,1,587.37,435a30.09,30.09,0,0,1-6.9-14.82,30.63,30.63,0,0,1,2.06-17l0,.24-86.69-95.09.27.07a30.84,30.84,0,0,1-16.9.48,30.5,30.5,0,0,1-22-36.73l.12-.48.33.36,9.18,10.12-.18-.08,14.05.68-.19.07L491,273.36l-.09.18c.23-4.74.46-9.41.69-14.05l.06.18-9.18-10.12-.31-.35.46-.06a30.49,30.49,0,0,1,29.1,12.5,30.32,30.32,0,0,1,5.51,14.73,31,31,0,0,1-2.35,15l0-.24,86.55,95.16-.12,0a30.32,30.32,0,0,1,24.9,2.93,31.78,31.78,0,0,1,5.24,4c1,1.07,1.54,1.62,1.54,1.62l-1.58-1.58a33.46,33.46,0,0,0-5.26-4,30.28,30.28,0,0,0-24.77-2.82l-.07,0,0-.06-86.71-95-.1-.11.06-.13a30.63,30.63,0,0,0,2.3-14.82,29.72,29.72,0,0,0-5.44-14.5,30,30,0,0,0-28.64-12.29l.15-.41L492,259.34l.07.07v.11q-.33,6.94-.68,14v.11l-.08.07-10.41,9.45-.08.07h-.11l-14-.69h-.11l-.07-.08-9.19-10.12.45-.11A30,30,0,0,0,496,307.9l.15,0,.12.12c31.48,34.58,61,66.95,86.63,95.13l.1.11-.06.14a30.3,30.3,0,0,0-2.05,16.72,30.19,30.19,0,0,0,19.4,23.39,30.12,30.12,0,0,0,14.46,1.5l-.12.31-9.17-10.12-.05-.06V435c.24-4.93.47-9.68.69-14v-.07l0-.05,10.43-9.43,0,0h.06l14,.7h0l0,0c3.36,3.72,6.45,7.13,9.16,10.14l-.18,0a30.21,30.21,0,0,0-2.59-21.21,33.33,33.33,0,0,0-3.07-4.74C633.33,395.39,632.92,394.88,632.92,394.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.19,296.17a2.64,2.64,0,0,1-.33.75,17.63,17.63,0,0,1-1.17,1.88,24.25,24.25,0,0,1-11.46,8.81,16.55,16.55,0,0,1-2.12.64,2.51,2.51,0,0,1-.8.13c0-.09,1.09-.39,2.79-1.11a27.64,27.64,0,0,0,11.3-8.68C510.53,297.12,511.11,296.13,511.19,296.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.76,332.26,567,318.86l-25.71-3.21,9.44,8s-33.24,11.59-33.82,14.2,2.62,9.63,8.48,8.33c0,0-3.29,4-1.92,8.41s4.4,5.24,10,4.21c0,0-3.8,5.69-.82,8.59s7.62,2.17,7.62,2.17.06,6.93,3.72,7.53,13.86-.11,17.67-1.28l19.35-6L593.55,367Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.82,341.06c.11.38-3.72,1.82-8.54,3.23s-8.84,2.23-8.95,1.85,3.72-1.83,8.54-3.23S542.71,340.68,542.82,341.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.71,354.73c.11.38-2.92,1.63-6.78,2.8s-7.09,1.79-7.21,1.41,2.93-1.63,6.79-2.79S547.6,354.36,547.71,354.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.1,366.1c.07.43-2.69,1-5.93,1.82s-5.77,2-6,1.59,2.15-2.06,5.6-3S552.05,365.75,552.1,366.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.73,322.5c.11.39-3.66,1.76-8.33,3.37s-8.48,2.84-8.64,2.47,3.46-2.21,8.18-3.83S555.63,322.12,555.73,322.5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.34 329.74 652.63 352.3 648.99 395.05 580.41 367.4 590.34 329.74",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.26,254.93s8.12,8.39,12.85,23.48,27,79.06,26.46,99.41c-.59,21.05-14.76,36.07-45.9,27.75-18.58-5-40.72-13-40.72-13l15.74-51.74L651,344l-19.88-37.32Z",
    style: {
      fill: "#7E7E84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656,279.38c.12.09-8.5,12.36-19.24,27.41S617.23,334,617.11,333.9s8.5-12.36,19.24-27.41S655.89,279.3,656,279.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.84,351s-.54-.26-1.51-.71a28.35,28.35,0,0,0-4.27-1.51c-1.85-.51-4.09-1-6.58-1.53l-8.08-1.78c-5.73-1.28-10.92-2.47-14.66-3.36l-4.43-1.08a9.38,9.38,0,0,1-1.61-.46,10.46,10.46,0,0,1,1.65.27l4.47.91c3.77.8,9,1.93,14.7,3.21l8.07,1.83c2.48.56,4.72,1.08,6.57,1.64a24.54,24.54,0,0,1,4.26,1.68,10.18,10.18,0,0,1,1.07.63A1.67,1.67,0,0,1,679.84,351Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M695.76,353.28a7.71,7.71,0,0,0-4.28-5.72,20.73,20.73,0,0,0-7.16-1.92c-11.19-1.54-22.51-2-33.8-2.39l1,.45a210.73,210.73,0,0,1,40.75,11.88,3.14,3.14,0,0,0,2.36.28A2.47,2.47,0,0,0,695.76,353.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.14,154.92c-10.5-1.79-23.06,1.26-33.56-.53-1.56-.26-3.28-.51-4.66.29-1.66.95-2.23,3.07-2.31,5a19,19,0,0,0,6,14.16,26.89,26.89,0,0,0,14.11,6.74c4.19.71,8.7.57,12.43-1.45C437.71,175.57,440.86,162.13,439.14,154.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,174.13s-6.37-7.47-7.29-10.91c-.61-2.28-.31-8.67,0-12.72a7,7,0,0,1,4.55-6.2,2.31,2.31,0,0,1,2.37.19,23.81,23.81,0,0,1,2.9-3.26c2.5-2.56,3.69-4.29,9.19-2.7,0,0,4.05-4.27,6.38-3.95a36,36,0,0,1,4.63,1s8.87-.38,10.69,2.44a8.13,8.13,0,0,0,4,2.67,11,11,0,0,1,6.33,5.77,22.91,22.91,0,0,1,1.77,7.73l-9,.36s.64,20.71-1.63,22.38-3.13,1.07-3.13,1.07-1.73,4.86-8.48,1.27c0,0-5.6,1.69-8-.62s-11.18-24.5-11.18-24.5l.25,11s4.63,7.13,2.36,8.8S398.39,174.13,398.39,174.13Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.63,146.06a7,7,0,0,1,.51,1.3l1.22,3.6c1,3,2.37,7.28,3.83,11.95s2.68,9,4.06,11.84a25.44,25.44,0,0,0,1.84,3.3c.49.75.8,1.13.77,1.16s-.11-.07-.27-.25a9.22,9.22,0,0,1-.66-.79,20.16,20.16,0,0,1-2-3.26c-1.49-2.89-2.74-7.18-4.22-11.84s-2.77-8.92-3.69-12c-.42-1.47-.78-2.69-1.06-3.65A7.6,7.6,0,0,1,409.63,146.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.7,143.5a6.67,6.67,0,0,1,.46,1.34l1.07,3.71c.87,3.13,2,7.47,3.32,12.27s2.39,9.16,3.17,12.32c.37,1.5.67,2.76.91,3.74a6.94,6.94,0,0,1,.26,1.4,8.77,8.77,0,0,1-.46-1.34c-.28-1-.63-2.22-1.06-3.71-.88-3.13-2.06-7.47-3.32-12.27s-2.39-9.16-3.18-12.32c-.36-1.51-.67-2.76-.9-3.75A7.43,7.43,0,0,1,420.7,143.5Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWrong);
export default __webpack_public_path__ + "static/media/SomethingWrong.af8fc97ad51cde91b5c690b8bf52a6ed.svg";
export { ForwardRef as ReactComponent };